// MelhorJogadorPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import HowToVoteRoundedIcon from '@mui/icons-material/HowToVoteRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import AppLayout from '../../../components/ui/AppLayout';
import PageHeader from '../../../components/ui/PageHeader';
import SectionCard from '../../../components/ui/SectionCard';
import LoadingState from '../../../components/ui/LoadingState';
import EmptyState from '../../../components/ui/EmptyState';
import PlayerAvatar from '../../../components/ui/PlayerAvatar';
import api from '../../../api';
import tokens from '../../../theme/tokens';

const MelhorJogadorPage = () => {
  const navigate = useNavigate();
  const [melhoresJogadores, setMelhoresJogadores] = useState([]);
  const [votos, setVotos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    api
      .get('/melhor-jogador')
      .then((response) => {
        setMelhoresJogadores(response.data.melhoresJogadores);
        setVotos(response.data.votos);
      })
      .catch((error) => console.error('Erro ao buscar o melhor jogador:', error))
      .finally(() => setIsLoading(false));
  }, []);

  const totalVotos = votos.length || 1;
  const [lider, ...demais] = melhoresJogadores;

  return (
    <AppLayout>
      <PageHeader
        backTo="/squad"
        eyebrow="Torneio"
        title="Melhor jogador"
        subtitle={`${votos.length} votos registrados pelos moradores`}
        actions={<Button variant="contained" startIcon={<HowToVoteRoundedIcon />} onClick={() => navigate('/melhorJogadorVoto')}>Votar</Button>}
      />
      {isLoading ? (
        <LoadingState />
      ) : !lider ? (
        <Card><EmptyState icon={<EmojiEventsRoundedIcon />} title="Nenhum voto ainda" description="Seja o primeiro a votar no melhor jogador do torneio." /></Card>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12} md={5}>
            <Card sx={{ p: 4, textAlign: 'center', color: '#fff', background: `radial-gradient(circle at 50% 0%, rgba(233,168,0,0.35), transparent 60%), linear-gradient(160deg, ${tokens.color.inkSoft}, ${tokens.color.ink})`, border: 'none', height: '100%' }}>
              <EmojiEventsRoundedIcon sx={{ fontSize: 40, color: tokens.color.gold }} />
              <Typography variant="overline" sx={{ display: 'block', opacity: 0.8 }}>Mais votado</Typography>
              <PlayerAvatar src={lider.foto} name={lider.nome} size={150} sx={{ mx: 'auto', my: 2, border: `4px solid ${tokens.color.gold}` }} />
              <Typography variant="h4">{lider.nome}</Typography>
              <Typography sx={{ opacity: 0.8 }}>{lider.votos} votos · {Math.round((lider.votos / totalVotos) * 100)}%</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={7}>
            <SectionCard title="Ranking de votos" sx={{ height: '100%' }}>
              <Stack spacing={2}>
                {[lider, ...demais].map((jogador, index) => (
                  <Stack key={jogador.nome} direction="row" spacing={1.5} alignItems="center">
                    <Typography sx={{ width: 20, fontWeight: 700, color: 'text.secondary' }}>{index + 1}</Typography>
                    <PlayerAvatar src={jogador.foto} name={jogador.nome} size={40} />
                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                      <Stack direction="row" justifyContent="space-between">
                        <Typography variant="body2" fontWeight={600} noWrap>{jogador.nome}</Typography>
                        <Typography variant="body2" color="text.secondary">{jogador.votos}</Typography>
                      </Stack>
                      <LinearProgress variant="determinate" value={(jogador.votos / totalVotos) * 100} sx={{ height: 6, borderRadius: 3, mt: 0.5 }} />
                    </Box>
                  </Stack>
                ))}
              </Stack>
            </SectionCard>
          </Grid>
          <Grid item xs={12}>
            <SectionCard title="Votos registrados">
              <Grid container spacing={1}>
                {votos.map((voto, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'background.default' }}>
                      <Typography variant="body2" fontWeight={600}>{voto.nome}</Typography>
                      <Typography variant="caption" color="text.secondary">Apto {voto.apartamento} · votou em {voto.jogador}</Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </SectionCard>
          </Grid>
        </Grid>
      )}
    </AppLayout>
  );
};

export default MelhorJogadorPage;
